import {h, Fragment} from "preact"
import { SerpElement } from "@nosto/preact"

export default function ProductCard({className = '', product}) {
    const handle = product.handle ? product.handle : product.url?.split('/')?.reverse()[0] || '';

    return handle ? (
        <SerpElement
            as="div"
            hit={product}
            
            ariaLabel={`Product ${product.name}`}
            class={
                "group relative col-span-3 md:col-span-3 lg:col-span-4 " + className
            }>
            <dynamic-product-card handle={handle}></dynamic-product-card>
        </SerpElement>
    ) : null
}